import type { PropsWithChildren } from "react";
import { classNames } from "@circle-react/helpers/twMergeWithCN";

interface ContainerProps {
  className?: string;
}

export const Container = ({
  children,
  className,
}: PropsWithChildren<ContainerProps>) => (
  <div className={classNames("flex h-full flex-col", className)}>
    {children}
  </div>
);
